import styles from './CertificatePopup.module.css';
import CardComponent from '../Card/Card'
import clsoeIcon from '../../assets/icons/CloseIconRed.svg';
import { animateCSS } from '../../helpers/globals';

export default function CertificatePopupComponent(props) {

    function closePopup() {
        const backdrop = document.getElementById("backdrop");
        if (backdrop) backdrop.style.backgroundColor = 'transparent';

        const popup = document.getElementById("popup");
        if (popup) popup.style.backgroundColor = 'transparent';

        const closeBtn = document.getElementById("closeBtn");
        if (closeBtn) closeBtn.style.visibility = 'hidden';

        animateCSS('#certificateDetails', 'animate__slideOutDown').then((message) => {
            // Do something after the animation
            props.toggleShowPopup(false);
        });
    }
    return (
        <>
            <div id='backdrop' className={styles.backdrop} onClick={closePopup}></div>
            <div id='popup' className={styles.popup}>
                <img id='closeBtn' src={clsoeIcon} alt="Close Button" className={styles.closeIcon} onClick={closePopup} />

                <div id='certificateDetails' className=' animate__animated animate__fadeInUp'>
                    <CardComponent item={props.popupData.card} />
                    <div className={styles.certificateImgContainer}>
                        {
                            props.popupData.popup.map(item =>
                                <picture key={item.id}>
                                    <source type="image/webp" media="(min-width:750px)" srcSet={item.image1x + ' 1x, ' + item.image2x + ' 2x'} alt={item.alt} />
                                    <source type="image/webp" media="(min-width:300px)" srcSet={item.imageM1x + ' 1x, ' + item.imageM2x + ' 2x'} alt={item.alt} />
                                    <img src={item.image1x} alt={item.alt} className={styles.certificateImg} />
                                </picture>)
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
